import { Card, FormSection } from "../../components/ui";
import { useBranding } from "../../context/BrandingContext";

/** Product and compliance facts. Deliberately carries no account identifiers,
 *  resource ids or environment secrets — this screen is visible to any user
 *  who can reach Settings. */
export function AboutSection() {
  const { language, appName } = useBranding();
  const ar = language === "ar";

  return (
    <div className="space-y-4">
      <Card>
        <FormSection legend={ar ? "المنتج" : "Product"}>
          <dl className="divide-y divide-line-hairline">
            {[
              [ar ? "التطبيق" : "Application", appName],
              [ar ? "الإصدار" : "Version", "0.1.0"],
              [ar ? "المنصة" : "Platform", "Cloudflare Workers · D1 · R2"],
            ].map(([k, v]) => (
              <div key={k} className="flex items-baseline justify-between gap-3 py-2.5">
                <dt className="text-sm text-ink-700">{k}</dt>
                <dd className="text-sm font-medium text-ink-900">{v}</dd>
              </div>
            ))}
          </dl>
        </FormSection>
      </Card>

      <Card>
        <FormSection legend={ar ? "الالتزام الضريبي" : "Tax compliance"}>
          <p className="text-sm text-ink-700">
            {ar
              ? "يولّد النظام رمز QR للفاتورة الضريبية المبسطة وفق المرحلة الأولى (TLV بترميز Base64)."
              : "The system generates a simplified tax invoice QR per Phase 1 (Base64-encoded TLV)."}
          </p>
          <p className="mt-2 text-xs text-muted-foreground">
            {ar
              ? "غير مرتبط بهيئة الزكاة والضريبة والجمارك، وغير معتمد منها. لا يشمل التنفيذ المرحلة الثانية (الفوترة الإلكترونية المرتبطة والتوقيع)."
              : "Not connected to or certified by ZATCA. Phase 2 (integrated e-invoicing and signing) is not implemented."}
          </p>
        </FormSection>
      </Card>
    </div>
  );
}
